import { Injectable } from '@angular/core';
import { ConfigService } from '@app/shared/services/config/config.service';

@Injectable({
  providedIn: 'root'
})
export class GoogleMapsLoader {
  private static promise: Promise<any>;
  private readonly googleLoadedWindowEvent = '__onGoogleLoaded';
  constructor(private configService: ConfigService) { }

  load(): Promise<any> {
    if (!GoogleMapsLoader.promise) {
      GoogleMapsLoader.promise = new Promise(resolve => {
        window[this.googleLoadedWindowEvent] = (_ev: unknown) => {
          resolve('google maps api loaded');
        };
        const node = document.createElement('script');
        node.src = this.getGoogleMapsApiUrl();
        node.type = 'text/javascript';
        document.getElementsByTagName('head')[0].appendChild(node);
      });
    }
    return GoogleMapsLoader.promise;
  }

  private getGoogleMapsApiUrl(): string {
    return `https://maps.googleapis.com/maps/api/js?key=${this.configService.config.mapsApiKey}&libraries=places&callback=__onGoogleLoaded`;
  }
}
